export const SET_QUIZ = 'SET_QUIZ';
export const SET_QUIZ_STATE = 'SET_QUIZ_STATE';
export const UPDATE_QUIZ_DATA = 'UPDATE_QUIZ_DATA';
export const SET_WHOLE_QUIZ_DATA = 'SET_WHOLE_QUIZ_DATA';
